import { Booking } from "@app/core/booking/domain/model/booking";

export class BookingMapper {
  static serialize(booking: Booking): any {
    return {
      ...booking,
      fecha: booking.date,
      hora_from: booking.hour_from,
      hora_to: booking.hour_to,
    };
  }
  static deserialize(response: any): Booking {
    const booking = response.match_request;
    return {
      ...booking,
      date: booking.fecha,
      hour_from: booking.hora_from.slice(0, booking.hora_from.length - 3),
      hour_to: booking.hora_to.slice(0, booking.hora_to.length - 3),
      court: booking.pista,
      payment_options: booking.payment_options,
      payment_type: booking.payment_type,
      coupon: booking.coupon[0] ?? null,
      has_person1_paid: booking?.payments_complete_list.some(
        (i: any) => i["user_email"] === booking.email1
      ),
      has_person2_paid: booking?.payments_complete_list.some(
        (i: any) => i["user_email"] === booking.email2
      ),
      has_person3_paid: booking?.payments_complete_list.some(
        (i: any) => i["user_email"] === booking.email3
      ),
      has_person4_paid: booking?.payments_complete_list.some(
        (i: any) => i["user_email"] === booking.email4
      ),
      checkout_messages: booking.checkout_messages,
      picture1: booking?.picture1,
      picture2: booking?.picture2,
      picture3: booking?.picture3,
      picture4: booking?.picture4,
      showDirections: booking?.google_maps_link,
      address: booking?.address,
      consent: booking?.consent,
      competitive: response.competitive ?? null,
      transactions: booking.transactions,
    };
  }
}
